import { styled } from '@mui/material/styles';

const VerticalTimeline = styled("div")(({ theme }) => ({
    textAlign: 'left',
    marginTop: 40,
    '& .custom-date-format': { color: '#FFF' }
}));

export default VerticalTimeline;